// Drop rules of the Fuhrpark Montage view (fleet_montage_controller). Pure so Vitest can pin them.
//
//   dragging: { item: "Fleet:12", kind: "attachment" | "tool", origin: "<carrier id>" | "" }
//   zone:     a dropzone's dataset — montageTargetId ("" = the pool), montageAccepts ("attachment tool")
//
// A zone takes a chip when it accepts its kind and is not where the chip already is: dropping a chip
// back on its own card, or a pool chip on the pool, does nothing.
export function canDrop(dragging, zone) {
  if (!dragging || !zone) return false

  const accepts = (zone.montageAccepts || "").split(/\s+/).filter(Boolean)
  if (!accepts.includes(dragging.kind)) return false

  return (zone.montageTargetId || "") !== (dragging.origin || "")
}

// The body the drop endpoint (Fleets::MontageMovesController) expects. The origin lets the server
// refuse a move off a carrier this page never showed the chip on (a stale page).
export function moveParams(dragging, zone) {
  return {
    item: dragging.item,
    origin: dragging.origin || "",
    target: zone.montageTargetId || "",
    from: "montage",
  }
}
